import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLocale } from "@/contexts/LocaleContext";
import PropertyCard from "@/components/PropertyCard";

export default function Favorites() {
  const { t } = useLocale();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/favorites").then(({ data }) => setItems(data)).catch(() => setItems([])).finally(() => setLoading(false));
  }, []);

  return (
    <div className="mx-auto max-w-7xl px-6 md:px-10 pt-12 md:pt-20 pb-16">
      <div className="mb-10">
        <div className="label-eyebrow text-secondary">{t("nav.favorites")}</div>
        <h1 className="mt-2 font-serif text-5xl md:text-6xl">{t("favorites.title")}</h1>
      </div>

      {loading ? (
        <div className="py-16 text-center text-muted-foreground text-sm">{t("common.loading")}</div>
      ) : items.length === 0 ? (
        <div className="py-16 text-center text-muted-foreground text-sm" data-testid="favorites-empty">{t("favorites.empty")}</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14" data-testid="favorites-grid">
          {items.map((p, i) => <PropertyCard key={p.property_id} property={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
